import React from 'react';
import { useIntegratedForm } from '../use-integrated-form';
import { FormButtonBase, FormButtonProps } from './form-button';

export function FormCancelButton(props: FormButtonProps): React.ReactElement {
    const integratedForm = useIntegratedForm();
    const buttonPropsMemo: FormButtonProps = React.useMemo(() => {
        return {
            variant: 'ghost',
            children: 'Cancel',
            ...integratedForm.getCancelButtonProps(),
            ...props,
        };
    }, [props, integratedForm]);

    return <FormButtonBase {...buttonPropsMemo} />;
}
